import * as React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles, FormGroup, FormControlLabel } from "@material-ui/core";
import { translate, InjectedTranslateProps } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { Dispatch } from 'redux';
import { closeEditAvailabilitiesDialog, updateAvailabilityDatepickerId } from '../../actions/store/app-actions';
import { ConnectedDatePicker } from "../datepicker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { updateAvailabilitiesByRange } from "../../actions/occupied-day-actions";
import Checkbox from "@material-ui/core/Checkbox";
import { formatDate } from "../../util/date-utility";

interface State {
	isDialogDisabled: boolean,
	dialogMode: "open" | "close",
	dialogDateFrom: Date,
	dialogDateTo: Date,
	dialogMonday: boolean;
	dialogTuesday: boolean;
	dialogWednesday: boolean;
	dialogThursday: boolean;
	dialogFriday: boolean;
	dialogSaturday: boolean;
	dialogSunday: boolean;
}

export interface EditAvailabilitiesDialogProps {}

type Props = EditAvailabilitiesDialogProps &
	ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps> &
	WithStyles<typeof styles> &
	InjectedTranslateProps;

export class EditAvailabilitiesDialog extends React.Component<Props, {}> {
	public readonly state: State = {
		isDialogDisabled: false,
		dialogMode: "open",
		dialogDateFrom: new Date(),
		dialogDateTo: new Date(),
		dialogMonday: true,
		dialogTuesday: true,
		dialogWednesday: true,
		dialogThursday: true,
		dialogFriday: true,
		dialogSaturday: true,
		dialogSunday: true
	};

	private form: HTMLFormElement;

	private handleFormRef = (ref: HTMLFormElement) => {
		this.form = ref;
	}

	private handleDialogClose = () => {
		const { close, updateAvailabilityDatepickerId } = this.props;

		close();
		updateAvailabilityDatepickerId();

		this.setState({ isDialogDisabled: false });
	};

	private handleDialogSubmitClick = async () => {
		const {
			dialogMode,
			dialogDateFrom,
			dialogDateTo,
			isDialogDisabled,
			dialogMonday,
			dialogTuesday,
			dialogWednesday,
			dialogThursday,
			dialogFriday,
			dialogSaturday,
			dialogSunday
		} = this.state;

		const weekdays = [
			dialogMonday ? "m" : "",
			dialogTuesday ? "t" : "",
			dialogWednesday ? "w" : "",
			dialogThursday ? "h" : "",
			dialogFriday ? "f" : "",
			dialogSaturday ? "a" : "",
			dialogSunday ? "u" : ""
		].join("");

		if(isDialogDisabled || weekdays.length == 0) return;

		this.setState({ isDialogDisabled: true });

		const isAvailable = (dialogMode == "open");
		const currentDate = new Date(dialogDateFrom);
		const endDate = new Date(dialogDateTo);
	
		await updateAvailabilitiesByRange(currentDate, endDate, weekdays, isAvailable);

		this.handleDialogClose();
	}

	private handleDateFromChange = (date: Date) => {
		const { dialogDateTo } = this.state;

		if(date.getTime() > dialogDateTo.getTime()) {
			this.setState({ dialogDateTo: date });
		}

		this.setState({ dialogDateFrom: date });
	};

	private handleDateToChange = (date: Date) => {
		const { dialogDateFrom } = this.state;

		if(date.getTime() < dialogDateFrom.getTime()) {
			this.setState({ dialogDateFrom: date });
		}

		this.setState({ dialogDateTo: date });
	};

	handleModeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		this.setState({ dialogMode: event.target.value });
	};

	public render() {
		const { classes, open } = this.props;
		const {
			isDialogDisabled,
			dialogMode,
			dialogDateFrom,
			dialogDateTo,
			dialogMonday,
			dialogTuesday,
			dialogWednesday,
			dialogThursday,
			dialogFriday,
			dialogSaturday,
			dialogSunday
		} = this.state;
		
		return (
			<Dialog
				open={open}
				onClose={this.handleDialogClose}
			>
				<DialogTitle>Zeitspanne</DialogTitle>
				<DialogContent>
					<form ref={this.handleFormRef}>
						<FormControl fullWidth>
							<InputLabel 
								required
							>
								Aktion
							</InputLabel>
							<Select
								value={dialogMode}
								onChange={this.handleModeChange}
								disabled={isDialogDisabled}
								fullWidth
							>
								<MenuItem value="open">
									Öffnen
								</MenuItem>
								<MenuItem value="close">
									Schließen
								</MenuItem>
							</Select>
						</FormControl>
						<div className={classes.formRow}>
							<ConnectedDatePicker
								onChange={this.handleDateFromChange}
								value={dialogDateFrom}
								datepickerProps={{
									id: "availableDateFrom",
									label: "Von",
									disabled: isDialogDisabled,
									disablePast: true,
									renderDay: null,
									required: true,
									className: classNames(
										classes.textField
									),
									InputProps: {
										value: formatDate(dialogDateFrom)
									}
								}}
								
							/>
							<ConnectedDatePicker
								onChange={this.handleDateToChange}
								value={dialogDateTo}
								datepickerProps={{
									id: "availableDateTo",
									label: "Bis",
									disabled: isDialogDisabled,
									minDate: dialogDateFrom,
									disablePast: true,
									renderDay: null,
									required: true,
									className: classNames(
										classes.textField
									),
									InputProps: {
										value: formatDate(dialogDateTo)
									}
								}}
							/>
						</div>
						<div className={classNames(
									classes.formRow,
									classes.formRowLast
								)}>
							<FormGroup
								className={classNames(
									classes.textField,
									classes.fullWidth
								)}
							>
								<FormControlLabel
									label="Mindestens 1 Tag auswählen"
									className={classNames(classes.inputLabel)}
									control={<></>}
								/>
								<div className={classes.formRowCheckbox}>
									<FormControlLabel
										label="Montag"
										control={
											<Checkbox
												id="monday"
												color="primary"
												className={classes.checkbox}
												checked={dialogMonday}
												disabled={isDialogDisabled}
												onChange={event =>
													this.setState({ 
														dialogMonday: event.target.checked
													})
												}
											/>
										}
									/>
									<FormControlLabel
										label="Dienstag"
										control={
											<Checkbox
												id="tuesday"
												color="primary"
												className={classes.checkbox}
												checked={dialogTuesday}
												disabled={isDialogDisabled}
												onChange={event =>
													this.setState({ 
														dialogTuesday: event.target.checked
													})
												}
											/>
										}
									/>
									<FormControlLabel
										label="Mittwoch"
										control={
											<Checkbox
												id="wednesday"
												color="primary"
												className={classes.checkbox}
												checked={dialogWednesday}
												disabled={isDialogDisabled}
												onChange={event =>
													this.setState({ 
														dialogWednesday: event.target.checked
													})
												}
											/>
										}
									/>
									<FormControlLabel
										label="Donnerstag"
										control={
											<Checkbox
												id="thursday"
												color="primary"
												className={classes.checkbox}
												checked={dialogThursday}
												disabled={isDialogDisabled}
												onChange={event =>
													this.setState({ 
														dialogThursday: event.target.checked
													})
												}
											/>
										}
									/>
									<FormControlLabel
										label="Freitag"
										control={
											<Checkbox
												id="friday"
												color="primary"
												className={classes.checkbox}
												checked={dialogFriday}
												disabled={isDialogDisabled}
												onChange={event =>
													this.setState({ 
														dialogFriday: event.target.checked
													})
												}
											/>
										}
									/>
									<FormControlLabel
										label="Samstag"
										control={
											<Checkbox
												id="saturday"
												color="primary"
												className={classes.checkbox}
												checked={dialogSaturday}
												disabled={isDialogDisabled}
												onChange={event =>
													this.setState({ 
														dialogSaturday: event.target.checked
													})
												}
											/>
										}
									/>
									<FormControlLabel
										label="Sonntag"
										control={
											<Checkbox
												id="sunday"
												color="primary"
												className={classes.checkbox}
												checked={dialogSunday}
												disabled={isDialogDisabled}
												onChange={event =>
													this.setState({ 
														dialogSunday: event.target.checked
													})
												}
											/>
										}
									/>
								</div>
							</FormGroup>
						</div>
					</form>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={this.handleDialogClose}
						disabled={isDialogDisabled}
					>
						Abbrechen
					</Button>
					<Button
						onClick={this.handleDialogSubmitClick}
						disabled={isDialogDisabled}
						color="primary"
					>
						Ausführen
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	open: state.editAvailabilitiesDialogOpen
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	close: () => dispatch(closeEditAvailabilitiesDialog()),
	updateAvailabilityDatepickerId: () => 
		dispatch(updateAvailabilityDatepickerId()),
});

const styles = (theme: Theme) =>
	createStyles({
		formRow: {
			display: "flex",
			margin: -10,
			marginTop: 10,

			"@media (max-width: 600px)": {
				display: "block"
			}
		},
		formRowLast: {
			"@media (max-width: 600px)": {
				marginTop: 20
			}
		},
		textField: {
			margin: 10,
			width: "calc(50% - 20px)",

			"@media (max-width: 600px)": {
				width: "calc(100% - 20px)"
			}
		},
		formRowCheckbox: {
			display: "flex",
			flexWrap: "wrap",
			columnGap: "20px",
			marginLeft: 10,
			marginRight: 10,

			"@media (max-width: 600px)": {
				flexDirection: "column"
			}
		},
		fullWidth: {
			width: "100%"
		},
		inputLabel: {
			marginLeft: 0,
			paddingTop: 0,
			display: "inline-flex",
			flex: "1 1 0px",
			"@media (max-width: 600px)": {
				width: "calc(100% - 20px)"
			}
		},
		checkbox: {
			containerType: "inline-size",
			height: "30px",
			width: "30px",
			"& + span": {
				width: 70
			}
		},
	}); 

export const ConnectedEditAvailabilitiesDialog = translate("translations")(
	withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(EditAvailabilitiesDialog))
);
